import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "circle-chart" }
const _hoisted_2 = { class: "alternative-title-header" }
const _hoisted_3 = {
  key: 0,
  class: "table-container"
}
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = ["x1", "x2"]
const _hoisted_7 = ["x1", "y1", "x2", "y2"]
const _hoisted_8 = ["x1", "y1", "x2", "y2"]
const _hoisted_9 = ["x1", "y1", "x2", "y2"]
const _hoisted_10 = ["x1", "x2", "y2"]
const _hoisted_11 = ["x1", "x2", "y2"]
const _hoisted_12 = { class: "headers" }
const _hoisted_13 = ["x", "y"]
const _hoisted_14 = ["x", "y"]
const _hoisted_15 = ["x", "y"]
const _hoisted_16 = ["x", "y"]
const _hoisted_17 = ["x", "y"]
const _hoisted_18 = ["x1", "y1", "x2", "y2"]
const _hoisted_19 = ["cx", "cy", "r"]
const _hoisted_20 = ["cx", "cy", "r"]
const _hoisted_21 = ["x", "y"]
const _hoisted_22 = ["x", "y"]
const _hoisted_23 = ["x", "y"]
const _hoisted_24 = { class: "footer-container" }
const _hoisted_25 = {
  key: 1,
  class: "separated-charts-container"
}
const _hoisted_26 = { class: "alternative-title" }
const _hoisted_27 = { class: "table-container" }
const _hoisted_28 = ["width", "height"]
const _hoisted_29 = { class: "grid" }
const _hoisted_30 = ["x1", "x2"]
const _hoisted_31 = ["x1", "y1", "x2", "y2"]
const _hoisted_32 = ["x1", "y1", "x2", "y2"]
const _hoisted_33 = ["x1", "y1", "x2", "y2"]
const _hoisted_34 = ["x1", "x2", "y2"]
const _hoisted_35 = ["x1", "x2", "y2"]
const _hoisted_36 = { class: "headers" }
const _hoisted_37 = ["x", "y"]
const _hoisted_38 = ["x", "y"]
const _hoisted_39 = ["x", "y"]
const _hoisted_40 = ["x", "y"]
const _hoisted_41 = ["x", "y"]
const _hoisted_42 = ["x1", "y1", "x2", "y2"]
const _hoisted_43 = ["cx", "cy", "r"]
const _hoisted_44 = ["cx", "cy", "r"]
const _hoisted_45 = ["x", "y"]
const _hoisted_46 = ["x", "y"]
const _hoisted_47 = ["x", "y"]
const _hoisted_48 = { class: "footer-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.alternativeTitle), 1),
    (_ctx.selectedAlternative !== 'all-separated')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", {
            width: _ctx.tableWidth,
            height: _ctx.tableHeight,
            class: "circle-svg"
          }, [
            _createElementVNode("g", _hoisted_5, [
              _createElementVNode("line", {
                x1: _ctx.labelWidth,
                y1: 0,
                x2: _ctx.tableWidth,
                y2: 0,
                stroke: "#ddd",
                "stroke-width": "1"
              }, null, 8, _hoisted_6),
              _createElementVNode("line", {
                x1: _ctx.labelWidth,
                y1: _ctx.headerHeight,
                x2: _ctx.tableWidth,
                y2: _ctx.headerHeight,
                stroke: "#ddd",
                "stroke-width": "1"
              }, null, 8, _hoisted_7),
              _createElementVNode("line", {
                x1: _ctx.labelWidth,
                y1: _ctx.headerHeight + _ctx.rowHeight,
                x2: _ctx.tableWidth,
                y2: _ctx.headerHeight + _ctx.rowHeight,
                stroke: "#ddd",
                "stroke-width": "1"
              }, null, 8, _hoisted_8),
              _createElementVNode("line", {
                x1: _ctx.labelWidth,
                y1: _ctx.headerHeight + _ctx.rowHeight * 2,
                x2: _ctx.tableWidth,
                y2: _ctx.headerHeight + _ctx.rowHeight * 2,
                stroke: "#ddd",
                "stroke-width": "1"
              }, null, 8, _hoisted_9),
              _createElementVNode("line", {
                x1: _ctx.labelWidth,
                y1: 0,
                x2: _ctx.labelWidth,
                y2: _ctx.headerHeight + _ctx.rowHeight * 2,
                stroke: "#ddd",
                "stroke-width": "1"
              }, null, 8, _hoisted_10),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsData.length, (index) => {
                return (_openBlock(), _createElementBlock("line", {
                  key: 'vline-' + index,
                  x1: _ctx.labelWidth + index * _ctx.cellWidth,
                  y1: 0,
                  x2: _ctx.labelWidth + index * _ctx.cellWidth,
                  y2: _ctx.headerHeight + _ctx.rowHeight * 2,
                  stroke: "#ddd",
                  "stroke-width": "1"
                }, null, 8, _hoisted_11))
              }), 128))
            ]),
            _createElementVNode("g", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsData, (data, index) => {
                return (_openBlock(), _createElementBlock("g", {
                  key: 'header-' + data.itemId
                }, [
                  (!_ctx.getSplitText(data.itemName).line2)
                    ? (_openBlock(), _createElementBlock("text", {
                        key: 0,
                        x: _ctx.getCellCenterX(index),
                        y: _ctx.headerHeight / 2 + 5,
                        "text-anchor": "middle",
                        "font-size": "13",
                        "font-weight": "500",
                        fill: "#333"
                      }, _toDisplayString(_ctx.getSplitText(data.itemName).line1), 9, _hoisted_13))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("text", {
                          x: _ctx.getCellCenterX(index),
                          y: _ctx.headerHeight / 2 - 5,
                          "text-anchor": "middle",
                          "font-size": "13",
                          "font-weight": "500",
                          fill: "#333"
                        }, _toDisplayString(_ctx.getSplitText(data.itemName).line1), 9, _hoisted_14),
                        _createElementVNode("text", {
                          x: _ctx.getCellCenterX(index),
                          y: _ctx.headerHeight / 2 + 10,
                          "text-anchor": "middle",
                          "font-size": "13",
                          "font-weight": "500",
                          fill: "#333"
                        }, _toDisplayString(_ctx.getSplitText(data.itemName).line2), 9, _hoisted_15)
                      ], 64))
                ]))
              }), 128))
            ]),
            _createElementVNode("text", {
              x: _ctx.labelWidth / 2,
              y: _ctx.headerHeight + _ctx.rowHeight / 2 + 5,
              "text-anchor": "middle",
              "font-size": "18",
              "font-weight": "500",
              fill: "#333"
            }, " + ", 8, _hoisted_16),
            _createElementVNode("text", {
              x: _ctx.labelWidth / 2,
              y: _ctx.headerHeight + _ctx.rowHeight * 1.5 + 5,
              "text-anchor": "middle",
              "font-size": "18",
              "font-weight": "500",
              fill: "#333"
            }, " - ", 8, _hoisted_17),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsData, (data, index) => {
              return (_openBlock(), _createElementBlock("g", {
                key: 'circles-' + data.itemId
              }, [
                (data.favorable > 0 && data.unfavorable > 0)
                  ? (_openBlock(), _createElementBlock("line", {
                      key: 0,
                      x1: _ctx.getCellCenterX(index),
                      y1: _ctx.getFavorableY() + _ctx.getCircleRadius(data.favorable),
                      x2: _ctx.getCellCenterX(index),
                      y2: _ctx.getUnfavorableY() - _ctx.getCircleRadius(data.unfavorable),
                      stroke: "#999",
                      "stroke-width": "1",
                      "stroke-dasharray": "3,3"
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true),
                (data.favorable > 0)
                  ? (_openBlock(), _createElementBlock("circle", {
                      key: 1,
                      cx: _ctx.getCellCenterX(index),
                      cy: _ctx.getFavorableY(),
                      r: _ctx.getCircleRadius(data.favorable),
                      fill: "#4CAF50",
                      stroke: "white",
                      "stroke-width": "2"
                    }, null, 8, _hoisted_19))
                  : _createCommentVNode("", true),
                (data.unfavorable > 0)
                  ? (_openBlock(), _createElementBlock("circle", {
                      key: 2,
                      cx: _ctx.getCellCenterX(index),
                      cy: _ctx.getUnfavorableY(),
                      r: _ctx.getCircleRadius(data.unfavorable),
                      fill: "#F44336",
                      stroke: "white",
                      "stroke-width": "2"
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true),
                (data.favorable > 0)
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 3,
                      x: _ctx.getCellCenterX(index),
                      y: _ctx.getFavorableY() + 5,
                      "text-anchor": "middle",
                      "font-size": "14",
                      "font-weight": "bold",
                      fill: "white"
                    }, _toDisplayString(data.favorable), 9, _hoisted_21))
                  : _createCommentVNode("", true),
                (data.unfavorable > 0)
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 4,
                      x: _ctx.getCellCenterX(index),
                      y: _ctx.getUnfavorableY() + 5,
                      "text-anchor": "middle",
                      "font-size": "14",
                      "font-weight": "bold",
                      fill: "white"
                    }, _toDisplayString(data.unfavorable), 9, _hoisted_22))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("text", {
              x: _ctx.labelWidth / 2,
              y: _ctx.headerHeight / 2 + 5,
              "text-anchor": "middle",
              "font-size": "11",
              "font-weight": "500",
              fill: "#666"
            }, _toDisplayString(_ctx.analysisPer === "stakeholder" ? "Stakeholder" : "Criterion"), 9, _hoisted_23)
          ], 8, _hoisted_4)),
          _createElementVNode("div", _hoisted_24, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "footer-label" }, [
              _createElementVNode("span", null, "Collective attitude")
            ], -1)),
            _createElementVNode("div", {
              class: "footer-values",
              style: _normalizeStyle({ width: (_ctx.tableWidth - _ctx.labelWidth) + 'px' })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsData, (data, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'footer-' + data.itemId,
                  class: "attitude-cell",
                  style: _normalizeStyle({ left: (index * _ctx.cellWidth) + 'px', width: _ctx.cellWidth + 'px' })
                }, _toDisplayString(data.attitude.toFixed(2)), 5))
              }), 128))
            ], 4)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.separatedChartsData, (altData, altId) => {
            return (_openBlock(), _createElementBlock("div", {
              key: altId,
              class: "alternative-chart-card"
            }, [
              _createElementVNode("h3", _hoisted_26, _toDisplayString(altData.name), 1),
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(), _createElementBlock("svg", {
                  width: altData.tableWidth,
                  height: altData.tableHeight,
                  class: "circle-svg"
                }, [
                  _createElementVNode("g", _hoisted_29, [
                    _createElementVNode("line", {
                      x1: _ctx.labelWidth,
                      y1: 0,
                      x2: altData.tableWidth,
                      y2: 0,
                      stroke: "#ddd",
                      "stroke-width": "1"
                    }, null, 8, _hoisted_30),
                    _createElementVNode("line", {
                      x1: _ctx.labelWidth,
                      y1: _ctx.headerHeight,
                      x2: altData.tableWidth,
                      y2: _ctx.headerHeight,
                      stroke: "#ddd",
                      "stroke-width": "1"
                    }, null, 8, _hoisted_31),
                    _createElementVNode("line", {
                      x1: _ctx.labelWidth,
                      y1: _ctx.headerHeight + _ctx.rowHeight,
                      x2: altData.tableWidth,
                      y2: _ctx.headerHeight + _ctx.rowHeight,
                      stroke: "#ddd",
                      "stroke-width": "1"
                    }, null, 8, _hoisted_32),
                    _createElementVNode("line", {
                      x1: _ctx.labelWidth,
                      y1: _ctx.headerHeight + _ctx.rowHeight * 2,
                      x2: altData.tableWidth,
                      y2: _ctx.headerHeight + _ctx.rowHeight * 2,
                      stroke: "#ddd",
                      "stroke-width": "1"
                    }, null, 8, _hoisted_33),
                    _createElementVNode("line", {
                      x1: _ctx.labelWidth,
                      y1: 0,
                      x2: _ctx.labelWidth,
                      y2: _ctx.headerHeight + _ctx.rowHeight * 2,
                      stroke: "#ddd",
                      "stroke-width": "1"
                    }, null, 8, _hoisted_34),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(altData.itemsData.length, (index) => {
                      return (_openBlock(), _createElementBlock("line", {
                        key: 'vline-alt-' + altId + '-' + index,
                        x1: _ctx.labelWidth + index * altData.cellWidth,
                        y1: 0,
                        x2: _ctx.labelWidth + index * altData.cellWidth,
                        y2: _ctx.headerHeight + _ctx.rowHeight * 2,
                        stroke: "#ddd",
                        "stroke-width": "1"
                      }, null, 8, _hoisted_35))
                    }), 128))
                  ]),
                  _createElementVNode("g", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(altData.itemsData, (data, index) => {
                      return (_openBlock(), _createElementBlock("g", {
                        key: 'header-alt-' + altId + '-' + data.itemId
                      }, [
                        (!_ctx.getSplitText(data.itemName).line2)
                          ? (_openBlock(), _createElementBlock("text", {
                              key: 0,
                              x: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                              y: _ctx.headerHeight / 2 + 5,
                              "text-anchor": "middle",
                              "font-size": "13",
                              "font-weight": "500",
                              fill: "#333"
                            }, _toDisplayString(_ctx.getSplitText(data.itemName).line1), 9, _hoisted_37))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("text", {
                                x: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                                y: _ctx.headerHeight / 2 - 5,
                                "text-anchor": "middle",
                                "font-size": "13",
                                "font-weight": "500",
                                fill: "#333"
                              }, _toDisplayString(_ctx.getSplitText(data.itemName).line1), 9, _hoisted_38),
                              _createElementVNode("text", {
                                x: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                                y: _ctx.headerHeight / 2 + 10,
                                "text-anchor": "middle",
                                "font-size": "13",
                                "font-weight": "500",
                                fill: "#333"
                              }, _toDisplayString(_ctx.getSplitText(data.itemName).line2), 9, _hoisted_39)
                            ], 64))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("text", {
                    x: _ctx.labelWidth / 2,
                    y: _ctx.headerHeight + _ctx.rowHeight / 2 + 5,
                    "text-anchor": "middle",
                    "font-size": "18",
                    "font-weight": "500",
                    fill: "#333"
                  }, " + ", 8, _hoisted_40),
                  _createElementVNode("text", {
                    x: _ctx.labelWidth / 2,
                    y: _ctx.headerHeight + _ctx.rowHeight * 1.5 + 5,
                    "text-anchor": "middle",
                    "font-size": "18",
                    "font-weight": "500",
                    fill: "#333"
                  }, " - ", 8, _hoisted_41),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(altData.itemsData, (data, index) => {
                    return (_openBlock(), _createElementBlock("g", {
                      key: 'circles-alt-' + altId + '-' + data.itemId
                    }, [
                      (data.favorable > 0 && data.unfavorable > 0)
                        ? (_openBlock(), _createElementBlock("line", {
                            key: 0,
                            x1: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                            y1: _ctx.headerHeight + _ctx.rowHeight / 2 + _ctx.getCircleRadiusSeparated(data.favorable, altData.itemsData),
                            x2: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                            y2: _ctx.headerHeight + _ctx.rowHeight * 1.5 - _ctx.getCircleRadiusSeparated(data.unfavorable, altData.itemsData),
                            stroke: "#999",
                            "stroke-width": "1",
                            "stroke-dasharray": "3,3"
                          }, null, 8, _hoisted_42))
                        : _createCommentVNode("", true),
                      (data.favorable > 0)
                        ? (_openBlock(), _createElementBlock("circle", {
                            key: 1,
                            cx: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                            cy: _ctx.headerHeight + _ctx.rowHeight / 2,
                            r: _ctx.getCircleRadiusSeparated(data.favorable, altData.itemsData),
                            fill: "#4CAF50",
                            stroke: "white",
                            "stroke-width": "2"
                          }, null, 8, _hoisted_43))
                        : _createCommentVNode("", true),
                      (data.unfavorable > 0)
                        ? (_openBlock(), _createElementBlock("circle", {
                            key: 2,
                            cx: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                            cy: _ctx.headerHeight + _ctx.rowHeight * 1.5,
                            r: _ctx.getCircleRadiusSeparated(data.unfavorable, altData.itemsData),
                            fill: "#F44336",
                            stroke: "white",
                            "stroke-width": "2"
                          }, null, 8, _hoisted_44))
                        : _createCommentVNode("", true),
                      (data.favorable > 0)
                        ? (_openBlock(), _createElementBlock("text", {
                            key: 3,
                            x: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                            y: _ctx.headerHeight + _ctx.rowHeight / 2 + 5,
                            "text-anchor": "middle",
                            "font-size": "14",
                            "font-weight": "bold",
                            fill: "white"
                          }, _toDisplayString(data.favorable), 9, _hoisted_45))
                        : _createCommentVNode("", true),
                      (data.unfavorable > 0)
                        ? (_openBlock(), _createElementBlock("text", {
                            key: 4,
                            x: _ctx.labelWidth + index * altData.cellWidth + altData.cellWidth / 2,
                            y: _ctx.headerHeight + _ctx.rowHeight * 1.5 + 5,
                            "text-anchor": "middle",
                            "font-size": "14",
                            "font-weight": "bold",
                            fill: "white"
                          }, _toDisplayString(data.unfavorable), 9, _hoisted_46))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("text", {
                    x: _ctx.labelWidth / 2,
                    y: _ctx.headerHeight / 2 + 5,
                    "text-anchor": "middle",
                    "font-size": "11",
                    "font-weight": "500",
                    fill: "#666"
                  }, _toDisplayString(_ctx.analysisPer === "stakeholder" ? "Stakeholder" : "Criterion"), 9, _hoisted_47)
                ], 8, _hoisted_28)),
                _createElementVNode("div", _hoisted_48, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-label" }, [
                    _createElementVNode("span", null, "Collective attitude")
                  ], -1)),
                  _createElementVNode("div", {
                    class: "footer-values",
                    style: _normalizeStyle({ width: (altData.tableWidth - _ctx.labelWidth) + 'px' })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(altData.itemsData, (data, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'footer-alt-' + altId + '-' + data.itemId,
                        class: "attitude-cell",
                        style: _normalizeStyle({ left: (index * altData.cellWidth) + 'px', width: altData.cellWidth + 'px' })
                      }, _toDisplayString(data.attitude.toFixed(2)), 5))
                    }), 128))
                  ], 4)
                ])
              ])
            ]))
          }), 128))
        ]))
  ]))
}